import script from "./AdminAlbumEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAlbumEdit.vue?vue&type=script&setup=true&lang=js"

import "./AdminAlbumEdit.vue?vue&type=style&index=0&id=3e0d984b&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0d984b"]])

export default __exports__